import { render, staticRenderFns } from "./StokEsleme.vue?vue&type=template&id=54dbfba2"
import script from "./StokEsleme.vue?vue&type=script&lang=js"
export * from "./StokEsleme.vue?vue&type=script&lang=js"
import style0 from "./StokEsleme.vue?vue&type=style&index=0&id=54dbfba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports